import { Card, CardContent, Chip, colors, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@material-ui/core";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from "clsx";
import { SlotTooltip } from "components";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import truncate from 'utils/truncate';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  table: {
    border: "1px #eeeeee solid",
    overflowX: "auto"
  },
  content: {
    overflowX: "auto"
  },
  cell: {
    border: "1px #eeeeee solid",
    flex: "1",
    display: "flex",
    minHeight: 120,
    justifyContent: "flex-end",
    paddingTop: 8,
    paddingRight: 8,
    overflowX: "auto"
  },
  row: {
    display: "flex"
  },
  header: {
    border: "1px #eeeeee solid",
    flex: "1",
    overflowX: "auto"
  },
  chip: {
    margin: theme.spacing(0.5)
  },
  card: {
    marginTop: theme.spacing(2)
  },
  slotslider: {
    flex: 1,
    overflowX: "auto"
  },
  buttons: {
    margin: theme.spacing(2)
  }
}));

const Calendar = props => {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const { date, slots, handleActivityOpen } = props;
  const [weeks, setWeeks] = useState([[], [], [], [], []]);
  const classes = useStyles()

  const get_chip_color = chip => {
    switch (chip.status) {
      case "scheduled":
        return { backgroundColor: colors.green["500"], color: "white" }
      case "concluded":
        return { backgroundColor: colors.grey["500"], color: "white" }
      case "closed":
        return { backgroundColor: colors.red["A700"], color: "white", textDecoration: "line-through" }
      default:
        break;
    }
  }

  const load_slots = (new_weeks) => {
    if (slots) {
      new_weeks = clear_slots(new_weeks);
      slots.forEach(slot => {
        let start_at = moment(slot.start_at);
        let date = start_at.date();
        let month = start_at.month();
        new_weeks.forEach(week => {
          week.forEach(day => {
            if (day.date === date && day.month === month) {
              day.slots.push(slot);
            }
          })
        });
      });
      return new_weeks;
    }
  }

  useEffect(() => {
    let new_weeks = load_slots(weeks);
    setWeeks(new_weeks);
  }, [slots]) //eslint-disable-line

  useEffect(() => {
    let new_weeks = [[], [], [], [], []];
    let cur_date = moment(date);
    let first_date = cur_date.date(1);
    let day_of_week = first_date.day();
    let previous_month = moment(cur_date).subtract(1, "M");
    let days_in_previous_month = previous_month.daysInMonth();
    let days_remaining = day_of_week % 7;
    for (let i = days_remaining; i > 0; i--) {
      new_weeks[0].push({ month: previous_month.month(), year: previous_month.year(), date: days_in_previous_month - i + 1, slots: [] });
    };
    let days_in_current_month = date.daysInMonth();
    let week_index = 0;
    for (let i = 1; i <= days_in_current_month; i++) {
      if (week_index === 5 && !new_weeks[week_index]) new_weeks.push([]);
      let week = new_weeks[week_index];
      week.push({ month: cur_date.month(), year: cur_date.year(), date: i, slots: [] });
      if (week.length === 7) week_index++;
    }
    let next_month_days = 7 - new_weeks[new_weeks.length - 1].length;
    let next_month = moment(cur_date).add(1, "M");
    for (let i = 1; i <= next_month_days; i++) {
      new_weeks[new_weeks.length - 1].push({ month: next_month.month(), year: next_month.year(), date: i, slots: [] });
    }
    new_weeks = load_slots(new_weeks);
    setWeeks([...new_weeks]);
  }, [date]); //eslint-disable-line

  const clear_slots = (weeks) => {
    let new_weeks = [...weeks];
    weeks.forEach(week => {
      week.forEach(day => {
        day.slots = [];
      })
    })
    return new_weeks;
  }

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow className={classes.row}>
              {days.map((day, index) => (
                <TableCell className={clsx(classes.header)} align="center" key={index}>{day}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {weeks.map((week, index) => (
              <TableRow className={classes.row} key={index}>
                {week.map((day, index1) => (
                  <TableCell widths={7} className={classes.cell} key={index1}>
                    <div className={classes.slotslider}>
                      {day.slots && day.slots.map((slot, index) => (
                        <LightTooltip interactive key={index}
                          title={
                            <SlotTooltip handleActivityOpen={handleActivityOpen} slot={slot} />
                          }
                          placement="right"
                        >
                          <Chip style={get_chip_color(slot)} clickable to={`/lesson_slots/${slot.id}/summary`} component={RouterLink} size="small" label={truncate(slot.name_en, 20)} className={classes.chip} />
                        </LightTooltip>))}
                    </div>
                    <div style={{ color: day.month !== date.month() ? "#839199" : null }}>{day.date}</div>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  )
}

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

export default Calendar;